import { createSelector } from '@reduxjs/toolkit';

import { DEFAULT_LIMITS_PARAMS_FORMATTER } from '@/constants/credit';

import configSelector from './config';

const creditLimitsParamsFormatterSelector = createSelector(
  configSelector,
  config => config.credit?.limitsParamsFormatter || DEFAULT_LIMITS_PARAMS_FORMATTER,
);

export default creditLimitsParamsFormatterSelector;
